export const ExternalIntegrationTypes = {
  AUTUMN_TRACK: "AUTUMN_TRACK",
  ATTENDANCE_ON_DEMAND: "ATTENDANCE_ON_DEMAND",
  UKG: "UKG",
} as const;

export type ExternalIntegrationType =
  typeof ExternalIntegrationTypes[keyof typeof ExternalIntegrationTypes];

export const ExtendedExternalIntegrationTypes = {
  ...ExternalIntegrationTypes,
  TIMECLOCK_COMPLIANCE: "TIMECLOCK_COMPLIANCE",
} as const;

export type ExtendedExternalIntegrationType =
  typeof ExtendedExternalIntegrationTypes[keyof typeof ExtendedExternalIntegrationTypes];
